import React from 'react';
import { BuildingOfficeIcon } from '../../Icons';

interface SalesProcessSidebarProps {
    owner: string | undefined;
    roleGroup: string;
    onClose: () => void;
}

/**
 * Componente que gestiona la visualización de la información del propietario
 * y las acciones globales dentro de la vista del proceso de venta.
 */
export const SalesProcessSidebar: React.FC<SalesProcessSidebarProps> = ({ 
    owner, 
    roleGroup, 
    onClose 
}) => {
    // Definimos si el perfil actual es restringido (Broker)
    const isRestrictedRole = roleGroup === 'BROKER';

    return (
        <div className="bg-sky-50 rounded-3xl p-8 border border-sky-100 shadow-sm sticky top-24">
            {!isRestrictedRole ? (
                <>
                    <BuildingOfficeIcon className="w-8 h-8 text-sky-600 mb-4" />
                    <h4 className="font-bold text-gray-800 mb-2 uppercase tracking-tight">Propietario</h4>
                    <p className="text-xl font-black text-sky-900 mb-6 uppercase leading-tight">
                        {owner || 'No especificado'}
                    </p>
                    <button 
                        onClick={onClose} 
                        className="w-full py-3 bg-white border border-sky-200 text-sky-600 font-black uppercase text-[10px] tracking-widest rounded-xl hover:bg-sky-100 transition-colors"
                    >
                        Cerrar Pestaña
                    </button>
                </>
            ) : (
                <div className="space-y-4">
                    <p className="text-[10px] font-black text-sky-600 uppercase tracking-widest text-center">
                        Acciones Disponibles
                    </p>
                    <button 
                        onClick={onClose} 
                        className="w-full py-4 bg-sky-600 text-white font-black uppercase text-[10px] tracking-widest rounded-xl hover:bg-sky-700 transition-all shadow-lg shadow-sky-100 active:scale-95"
                    >
                        Cerrar Pestaña
                    </button>
                </div>
            )}
        </div>
    );
};